var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-message"},[_c(_setup.Info,{attrs:{"width":"22","height":"22","color":_setup.PaletteColors['danger']}}),_vm._v(" "+_vm._s(_setup.props.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }